














































































import { Vue, Component, Prop } from "@/shared/vuepack";
import { optimizationSets } from "@/employer/optimizationSets";
import { useThemeStore } from "@/shared/store/theme";
@Component
export default class OptimizeModal extends Vue {
  @Prop() showModal!: boolean;
  @Prop() metricName!: string;

  headerIcon = "fa-solid fa-circle-arrow-up";
  emptyBlockErrorWorkaround = false;
  themeStore = useThemeStore();
  get shouldShow () {
    return this.showModal;
  }

  // This has to be here to keep vue warning out of console (computed property has no setter)
  set shouldShow (value) {
    this.emptyBlockErrorWorkaround = value;
  }

  handleHide () {
    this.$emit("closeModal");
  }

  onClose () {
    // Trigger the modal hide event as emiting close to parent causes the modal to hide but then modal's @hide emits the close again.
    this.$root.$emit("bv::hide::modal", "optimize-modal");
  }

  get modalValues () {
    return this.metricName !== undefined ? optimizationSets[this.metricName?.toUpperCase()] : undefined;
  }

  get title () {
    return this.modalValues?.title;
  }

  get description () {
    return this.modalValues?.description;
  }

  get resources () {
    return this.modalValues ? [this.modalValues?.leftTile, this.modalValues?.rightTile] : [];
  }

  onTileClick (url: string) {
    window.open(url, "_blank");
  }
}
